var loginfo = [];
/**
 * memo浅比较，指定paths进行深度比较
 * @param prev
 * @param next
 * @param paths 需要深度比较的路径，正则表达式
 * @param current
 */
var compare = function (prev, next, paths, current) {
    if (current === void 0) { current = ''; }
    if (!current) {
        loginfo.length = 0;
    }
    // 第一关：保证两者都是基本数据类型，基础数据类型直接比较出结果
    if (prev == null && next == null)
        return true;
    if (typeof prev !== 'object' && typeof next !== 'object' && prev === next) {
        // loginfo.push([current, true]);
        return true;
    }
    // 第二关：只要有一个不是对象数据类型就返回 false
    if (typeof prev !== 'object' || prev === null || typeof next !== 'object' || next === null) {
        loginfo.push([current, false, prev, next]);
        return false;
    }
    // 第三关：在这里已经可以保证两个都是对象数据类型，比较两者的属性数量
    var prevKeys = Object.keys(prev);
    var nextKeys = Object.keys(next);
    if (prevKeys.length !== nextKeys.length) {
        loginfo.push([current, false, prev, next]);
        return false;
    }
    var isEqual = true;
    if (!current || paths.some(function (regexp) { return regexp.test(current); })) {
        // 第四关：比较两者的属性是否相等，值是否相等
        for (var i = 0, key = void 0, path = void 0; i < prevKeys.length; i++) {
            key = prevKeys[i];
            path = current ? current + "." + key : key;
            if (!compare(prev[key], next[key], paths, path)) {
                isEqual = false;
            }
        }
    }
    else {
        isEqual = prev === next;
        var info = [current, isEqual];
        if (!isEqual) {
            info.push(prev, next);
            loginfo.push(info);
        }
    }
    return isEqual;
};
export var memoCompare = { compare: compare, loginfo: loginfo };
export default memoCompare;
//# sourceMappingURL=memoCompare.js.map